import "./DealerPromosPage.css";
import React from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../components/common/Header/Header";
import { BellIcon, ChevronRightIcon, GiftIcon, WarningIcon } from "../../components/common/Icons/Icons";
import { isColdTub } from "../../utils/brand";

// The only app that receives promos and push notifications, per brand
const targetApp = isColdTub ? 'Cold Tub Dealer app' : 'Arctic Spas v6.0.0 app or above';

// Both tiles show unconditionally — the route's permission gate already covers who gets
// here, and /promos and /notifications each re-check their own permissions on arrival.
const choices = [
  {
    path: '/promos',
    icon: <GiftIcon/>,
    title: 'Custom Promo',
    text: 'Create and manage promos for dealerships',
  },
  {
    path: '/notifications',
    icon: <BellIcon/>,
    title: 'Push Notification',
    text: 'Send push notifications to users via their app',
  },
];

const DealerPromosPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="page lp-page">
      <Header header="Dealer Promos" />
      <main className="lp-main">
        <div className="dp">
          <div className="dp-notice" role="note">
            <WarningIcon/>
            <p>
              Promos and push notifications are delivered only to the <strong>{targetApp}</strong>.
            </p>
          </div>

          <h1 className="dp-question">What would you like to send?</h1>

          <div className="dp-choices">
            {choices.map((choice) => (
              <a
                key={choice.path}
                href={choice.path}
                className="card card-link dp-choice"
                onClick={(e) => {
                  if (e.metaKey || e.ctrlKey || e.shiftKey) return;
                  e.preventDefault();
                  navigate(choice.path);
                }}
              >
                <span className="dp-icon" aria-hidden="true">{choice.icon}</span>
                <span className="dp-text">
                  <span className="dp-title">{choice.title}</span>
                  <span className="dp-desc">{choice.text}</span>
                </span>
                <ChevronRightIcon className="dp-chevron"/>
              </a>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
};

export default DealerPromosPage;
